<template>
  <v-layout>
    <div class="page-banner banner-about">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-logo-letters" />About Us</h1>
        <p>Who we are and what we do.</p>
      </div>
    </div>

    <el-container class="about-us-container">
      <el-main class="site-inner slim-container">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>CEO & Founder - Geoff Ingalls, PSM</h2>
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <img
              class="image-scale"
              alt="CEO Geoff Ingalls headshot"
              src="/img/ceo-geoff-ingalls.jpg" >
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <h3>Now</h3>
            <p>Starting in 2006, Geoff worked to find clients for the infant version of what would become Ingalls Image
            while attending High School during the day and meeting with clients at night. This started the business
            model of Ingalls Image where Geoff would use his connections with designers and developers to do the work
            while he would meet with clients and gather requirements.</p>
          </el-col>
          <el-col :xs="24">
            <h3>Then</h3>
            <p>Since then, he has done work for the United States Military, working on communication hardware used
            by soldiers to talk to their loved ones. He has worked for multiple marketing agencies as a web designer
            & developer creating wire-frames, mock-ups, websites, email campaigns, and eCommerce sites. Geoff has
            also worked as a project manager and as a Scrum Master, working with teams of developers to plan
            timelines, set deadline and milestones, make presentations to agency clients, help train agency clients
            and developers, and work to create requirements documents.</p>
          </el-col>
          <el-col :xs="24">
            <h3>Also</h3>
            <p>Formerly a professor at Southern New Hampshire University, Geoff spends his spare time as an assistant
            instructor at the Manchester Karate Studio, where he also trained to achieve his Black Belt. Geoff is
            also a fan of Dungeons and Dragons, has created his own Role Playing Game systems, and has published
            tutorial books for using Adobe Creative Suite programs.</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <el-container class="about-us-container">
      <el-main class="site-inner slim-container">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>Chief Technical Officer - Greg Ingalls, Sr.</h2>
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <h3>Now</h3>
            <p>As the man responsible for keeping the lights on, Greg makes sure the servers are up and running, any
            domains are renewed, software is up-to-date, and works as a web developer when the workload increases.
            Greg also makes sure invoices are sent out when needed and takes point on many of the promotional
            products work. Greg bring knowledge and experience to Ingalls Image, making sure that the future is
            planned out and adds focus to everyone, keeping us true to that plan.</p>
          </el-col>
          <el-col
            :xs="24"
            :sm="12">
            <img
              class="image-scale article-bottom-margin"
              alt="COO Greg Ingalls headshot"
              src="/img/coo-greg-ingalls.jpg" >
          </el-col>
          <el-col :xs="24">
            <h3>Then</h3>
            <p>A former High School Teacher & Professor at Southern New Hampshire University, Greg started his own
            computer repair company while he was still teaching. Working for school districts, helping to set up
            their network infrastructure and computers, as well as repairing any broken machines. Greg would retire
            from teaching and grow his business into a web design and development company that would service southern
            New Hampshire.</p>
          </el-col>
          <el-col :xs="24">
            <h3>Also</h3>
            <p>A member of the Manchester Karate Studio, and working towards his Black Belt, Greg enjoys playing the
            keyboard and has made multiple trips to Maine to play with his old band. When he is not playing the
            keyboard he is practicing martial arts getting ready for his black belt test.</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </v-layout>
</template>

<script>
import ServiceSection from '@/layouts/sections/services.vue';
import ServiceArticle from '@/layouts/articles/service.vue';
import 'element-ui/lib/theme-chalk/display.css';

/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'AboutUs',

  metaInfo: {
    title: 'Ingalls Image', // set a title
    titleTemplate: 'About Us | %s', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en',
      amp: undefined, // "amp" has no value
    },
    meta: [
      { itemprop: 'name', content: 'About Us | Ingalls Image' },
      { itemprop: 'description', content: 'Who we are and why we do this.' },
      { itemprop: 'image', content: 'https://www.ingallsimage.com/img/open-graph/about-us.jpg' },
      { property: 'og:title', content: 'About Us | Ingalls Image' },
      { property: 'og:description', content: 'Who we are and why we do this.' },
      { name: 'description', property: 'description', content: 'Who we are and why we do this.' },
      { property: 'og:image', content: 'https://www.ingallsimage.com/img/open-graph/about-us.jpg' },
      { property: 'og:url', content: 'https://www.ingallsimage.com/about-us' },
    ],
    link: [
      { rel: 'canonical', href: 'https://www.ingallsimage.com/about-us' },
    ],
  },
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
    ServiceSection,
    ServiceArticle,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$ga.page(this.$router);
  },
  methods: {
    collapseToggle(e) {
      let parent = e.target.parentElement;
      if (parent.nodeName === 'H4') {
        parent = e.target.parentElement.parentElement;
      }
      const grandParent = parent.parentElement;
      const main = parent.nextSibling;
      if (main.style.maxHeight) {
        main.style.maxHeight = null;
        grandParent.classList.remove('collapse-active');
      } else {
        main.style.maxHeight = `${main.scrollHeight}px`;
        grandParent.classList.add('collapse-active');
      }
    },
  },
};
</script>
